<template>
  <div class="site-page detail-page">
    <div class="site-container detail-wrap">
      <div class="page-breadcrumb">
        <span @click="$router.push('/home')">首页</span>
        <span class="sep">></span>
        <span @click="$router.push(newsListRoute)">资讯中心</span>
        <span class="sep">></span>
        <span class="current">资讯详情</span>
      </div>

      <div class="detail-grid">
        <div class="left-col">
          <article class="section-card article-card">
            <h1>{{ currentNews.title }}</h1>
            <div class="meta">
              <span>{{ currentNews.date }}</span>
              <span>·</span>
              <span>{{ currentNews.tag }}</span>
              <span>·</span>
              <span>{{ currentNews.viewCount }}阅读</span>
            </div>

            <div v-if="currentNews.contentHtml" class="article-body" v-html="currentNews.contentHtml"></div>
            <div v-else class="article-body">
              <p v-for="paragraph in currentNews.content" :key="paragraph">{{ paragraph }}</p>
            </div>

            <div class="article-nav">
              <router-link v-if="prevNews" :to="newsPath(prevNews.id)">上一条：{{ prevNews.title }}</router-link>
              <span v-else>上一条：没有了</span>
              <router-link v-if="nextNews" :to="newsPath(nextNews.id)">下一条：{{ nextNews.title }}</router-link>
              <span v-else>下一条：没有了</span>
            </div>
          </article>

          <section class="section-card related-card">
            <h2>相关资讯</h2>
            <ul>
              <li v-for="item in relatedNews" :key="item.id">
                <router-link :to="newsPath(item.id)">{{ item.title }}</router-link>
                <span>{{ item.date }}</span>
              </li>
            </ul>
          </section>
        </div>

        <aside class="right-col">
          <section class="section-card side-card" v-for="group in sideGroups" :key="group.title">
            <h3>{{ group.title }}</h3>
            <ul>
              <li v-for="item in group.items" :key="item.id" @click="$router.push(newsPath(item.id))">{{ item.title }}</li>
            </ul>
          </section>
        </aside>
      </div>
    </div>

    <div class="float-tools">
      <button class="tool-btn" type="button" @click="scrollTop">
        <img src="@/assets/imgs/ysgj_006@2x.png" alt="顶部">
      </button>
      <button class="tool-btn" type="button" @click="showMessage">
        <img src="@/assets/imgs/ysgj_007@2x.png" alt="咨询">
      </button>
    </div>
  </div>
</template>

<script>
import {
  buildNewsDetailPath,
  getNewsById,
  newsList,
  newsTypeOptions,
} from '@/data/siteData'
import { getNewsDetail } from '@/api'

export default {
  name: 'NewsDetail',
  data() {
    return {
      detailData: null,
    }
  },
  created() {
    this.fetchNewsDetail()
  },
  computed: {
    currentNews() {
      if (this.detailData) {
        return this.detailData
      }

      return getNewsById(this.$route.params.id) || newsList[0]
    },
    currentIndex() {
      if (this.detailData) {
        return -1
      }

      return newsList.findIndex((item) => item.id === this.currentNews.id)
    },
    prevNews() {
      if (this.detailData) {
        return this.detailData.prev
      }

      return this.currentIndex > 0 ? newsList[this.currentIndex - 1] : null
    },
    nextNews() {
      if (this.detailData) {
        return this.detailData.next
      }

      return this.currentIndex >= 0 && this.currentIndex < newsList.length - 1
        ? newsList[this.currentIndex + 1]
        : null
    },
    relatedNews() {
      if (this.detailData) {
        return Array.isArray(this.detailData.relatedNews) ? this.detailData.relatedNews : []
      }

      return newsList
        .filter((item) => item.id !== this.currentNews.id)
        .filter((item) => item.category === this.currentNews.category || item.type === this.currentNews.type)
        .slice(0, 5)
    },
    sideGroups() {
      if (this.detailData && Array.isArray(this.detailData.sideGroups)) {
        return this.detailData.sideGroups
      }

      return newsTypeOptions.map((group) => ({
        title: group.label,
        items: newsList.filter((item) => item.type === group.value).slice(0, 5),
      }))
    },
    newsListRoute() {
      return { path: '/news', query: { tab: this.currentNews.type } }
    },
  },
  watch: {
    '$route.params.id'() {
      this.fetchNewsDetail()
    },
  },
  methods: {
    async fetchNewsDetail() {
      try {
        const data = await getNewsDetail(this.$route.params.id)
        this.detailData = data && data.id ? data : null
      } catch (error) {
        this.detailData = null
      }
    },
    newsPath(id) {
      return buildNewsDetailPath(id)
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showMessage() {
      this.$Message.info('在线咨询功能开发中...')
    },
  },
}
</script>

<style scoped>
.detail-wrap {
  padding-top: 14px;
}

.detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 270px;
  gap: 14px;
}

.article-card {
  padding: 20px;
}

.article-card h1 {
  font-size: 32px;
  line-height: 1.35;
  color: #3b4860;
  font-weight: 700;
  margin-bottom: 10px;
}

.meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #a0a8b3;
  margin-bottom: 14px;
}

.article-card p {
  font-size: 14px;
  line-height: 1.95;
  color: #576172;
  margin-bottom: 12px;
}

.article-body {
  font-size: 14px;
  line-height: 1.95;
  color: #576172;
}

.article-body /deep/ * {
  max-width: 100%;
}

.article-body /deep/ p {
  margin: 0 0 12px;
}

.article-body /deep/ h1,
.article-body /deep/ h2,
.article-body /deep/ h3,
.article-body /deep/ h4 {
  color: #46536b;
  font-weight: 700;
  line-height: 1.55;
}

.article-body /deep/ h1 {
  font-size: 24px;
  margin: 24px 0 14px;
}

.article-body /deep/ img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 14px auto;
  border-radius: 8px;
}

.article-body /deep/ h2,
.article-body /deep/ h3 {
  margin: 18px 0 10px;
}

.article-body /deep/ h2 {
  font-size: 20px;
}

.article-body /deep/ h3 {
  font-size: 17px;
}

.article-body /deep/ h4 {
  margin: 14px 0 8px;
  font-size: 15px;
}

.article-body /deep/ ul,
.article-body /deep/ ol {
  padding-left: 20px;
  margin: 0 0 12px;
}

.article-body /deep/ li {
  margin-bottom: 6px;
}

.article-body /deep/ a {
  color: #1d5da8;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  word-break: break-word;
  transition: color 0.2s ease;
}

.article-body /deep/ a:hover {
  color: #0f4b91;
}

.article-body /deep/ strong,
.article-body /deep/ b {
  color: #33445b;
  font-weight: 700;
}

.article-body /deep/ blockquote {
  margin: 16px 0;
  padding: 14px 16px;
  border-left: 4px solid #1d5da8;
  border-radius: 0 8px 8px 0;
  background: #f4f8fc;
  color: #506175;
}

.article-body /deep/ hr {
  border: none;
  border-top: 1px solid #e5edf5;
  margin: 20px 0;
}

.article-body /deep/ table {
  width: 100%;
  margin: 14px 0;
  border-collapse: collapse;
  border-spacing: 0;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #e2eaf2 inset;
  display: block;
  overflow-x: auto;
}

.article-body /deep/ table tbody,
.article-body /deep/ table thead {
  width: 100%;
}

.article-body /deep/ th,
.article-body /deep/ td {
  min-width: 120px;
  padding: 10px 12px;
  border: 1px solid #e2eaf2;
  text-align: left;
  vertical-align: top;
  font-size: 13px;
  line-height: 1.8;
  color: #576172;
  background: #fff;
}

.article-body /deep/ th {
  background: #f6f9fc;
  color: #3f536b;
  font-weight: 700;
}

.article-body /deep/ pre {
  margin: 14px 0;
  padding: 14px 16px;
  border-radius: 10px;
  background: #1f2937;
  color: #f8fafc;
  line-height: 1.75;
  overflow-x: auto;
  font-size: 13px;
}

.article-body /deep/ code {
  padding: 2px 6px;
  border-radius: 6px;
  background: #f3f6fa;
  color: #28507f;
  font-size: 13px;
}

.article-body /deep/ pre code {
  padding: 0;
  background: transparent;
  color: inherit;
}

.article-nav {
  margin-top: 18px;
  border-top: 1px solid #edf1f6;
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.article-nav a,
.article-nav span {
  font-size: 13px;
  color: #6288b7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-card {
  margin-top: 12px;
  padding: 16px 20px;
}

.related-card h2 {
  font-size: 16px;
  color: #425068;
  margin-bottom: 10px;
}

.related-card ul li {
  height: 34px;
  border-bottom: 1px dashed #e7edf5;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
}

.related-card ul li:last-child {
  border-bottom: none;
}

.related-card ul li a {
  font-size: 13px;
  color: #5f6a79;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-card ul li a:hover {
  color: #4772a8;
}

.related-card ul li span {
  font-size: 12px;
  color: #a5adba;
}

.side-card {
  padding: 14px;
  margin-bottom: 12px;
}

.side-card h3 {
  font-size: 15px;
  color: #435068;
  margin-bottom: 8px;
}

.side-card li {
  padding: 8px 0;
  border-bottom: 1px dashed #e7edf5;
  font-size: 12px;
  color: #727d8d;
  line-height: 1.5;
  cursor: pointer;
}

.side-card li:last-child {
  border-bottom: none;
}

.side-card li:hover {
  color: #4772a8;
}

.float-tools .tool-btn {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.float-tools .tool-btn img {
  width: 46px;
  height: 46px;
}

</style>
